import * as actions from './actions';

export default {
  namespaced: true,
  mutations: {
    SET_TABLE_SEARCH_QUERY(state, payload) {
      state.tableSearchQuery = payload;
    },
    SET_TABLE_DATA(state, payload) {
      state.tableData = payload;
    },
    SET_TABLE_LOADING(state, payload) {
      state.tableLoading = payload;
    },
    SET_PAGE_TOTAL(state, payload) {
      state.pageTotal = payload;
    },
    SET_PAGE_CURRENT(state, payload) {
      state.pageCurrent = payload;
    },
    SET_PAGE_QUERY(state, payload) {
      state.pageQuery = payload;
    },
    SET_SELECTED_SIZE(state, payload) {
      state.selectedSize = payload;
    },
    SET__MAX_SELECTED_SIZE(state, payload) {
      state.maxSelectedSize = payload;
    },
    SET_IS_ALL(state, payload) {
      state.isAll = payload;
    }
  },
  actions,
  getters: {
    doneTodos: state => {
      return state.todos.filter(todo => todo.done);
    }
  },
  state: {
    // 查询表单
    tableSearchQuery: {},

    // 表格数据
    tableData: [],
    tableLoading: false,

    //分页相关
    pageTotal: 0,
    pageQuery: {
      pageSize: 50,
      pageNo: 1
    },

    // 已选项
    selectedSize: 0,
    // 全部选择状态
    isAll: false
  }
  // getters
};
